import request from '@/utils/request';

export function orderInfos(params) {
  return request({
    url: '/lianyungang-platform/api/apply/orderInfos',
    method: 'get',
    params,
  });
}

// 投标保函列表api
export function getOrderInfos(params) {
  return request({
    url: '/lianyungang-platform/api/bidApply/orderInfos',
    method: 'get',
    params,
  });
}

export function cetRandom(params) {
  return request({
    url: '/lianyungang-platform/api/accCertification/cetRandom',
    method: 'get',
    params,
  });
}
export function certVerify(params) {
  return request({
    url: '/lianyungang-platform/api/accCertification/certVerify',
    method: 'post',
    params,
  });
}
export function orderInfoGive(params) {
  return request({
    url: '/lianyungang-platform/orderInfoApi/orderInfoGive',
    method: 'post',
    params,
  });
}

export default { orderInfos, cetRandom, certVerify, orderInfoGive };
